import React, { useState, useCallback } from "react";
import { Button, Drawer, Typography, Space, Badge } from "antd";
import { SettingOutlined, CloseOutlined, BlockOutlined } from "@ant-design/icons";
import SidePanel from "../SidePanel";

const { Text } = Typography;

/**
 * 可折叠的侧边栏组件
 * 默认隐藏，通过按钮展开显示内容块控制面板
 */
const CollapsibleSidePanel = ({
    enableV2Mode,
    sidePanelSections,
    contentBlockInstances,
    onInstanceHover,
    onInsertBlock,
    onInsertInlineBlock,
    onRemoveBlock,
    onUpdateBlock,
    className = ""
}) => {
    const [visible, setVisible] = useState(false);

    const handleToggle = useCallback(() => {
        setVisible(prev => !prev);
    }, []);

    const handleClose = useCallback(() => {
        setVisible(false);
    }, []);

    // 计算已插入的内容块数量
    const insertedCount = contentBlockInstances.filter(instance => instance.isInserted).length;
    const totalCount = contentBlockInstances.length;

    return (
        <>
            {/* 触发按钮 - 固定在右侧 */}
            <div className={`side-panel-trigger ${className}`}>
                                    <Button
                        type="primary"
                        icon={<BlockOutlined />}
                        onClick={handleToggle}
                        style={{
                            position: "fixed",
                            right: "20px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            zIndex: 1000,
                            borderRadius: "20px 0 0 20px",
                            paddingLeft: "12px",
                            paddingRight: "8px",
                            height: "40px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                            transition: "all 0.3s ease",
                            border: "none"
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.transform = "translateY(-50%) scale(1.05)";
                            e.target.style.boxShadow = "0 4px 12px rgba(0,0,0,0.2)";
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.transform = "translateY(-50%) scale(1)";
                            e.target.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
                        }}
                    >
                    <Space size={4}>
                        <Text style={{ color: "white", fontSize: "12px" }}>
                            内容块
                        </Text>
                        {totalCount > 0 && (
                            <Badge 
                                count={insertedCount} 
                                size="small" 
                                style={{ 
                                    backgroundColor: "#52c41a",
                                    color: "white"
                                }}
                            />
                        )}
                    </Space>
                </Button>
            </div>

            {/* 抽屉面板 */}
            <Drawer
                title={
                    <Space>
                        <BlockOutlined />
                        <Text strong>
                            {enableV2Mode ? "内容块控制" : "内容库"}
                        </Text>
                        {totalCount > 0 && (
                            <Badge 
                                count={`${insertedCount}/${totalCount}`} 
                                style={{ 
                                    backgroundColor: "#1890ff",
                                    color: "white"
                                }}
                            />
                        )}
                    </Space>
                }
                placement="right"
                width={350}
                open={visible}
                onClose={handleClose}
                closeIcon={<CloseOutlined />}
                styles={{
                    header: {
                        borderBottom: "1px solid #f0f0f0",
                        paddingBottom: "12px"
                    },
                    body: {
                        padding: "16px 12px"
                    }
                }}
            >
                <div className="collapsible-side-panel-content">
                    <SidePanel
                        sections={sidePanelSections}
                        enableV2Mode={enableV2Mode}
                        contentBlockInstances={contentBlockInstances}
                        onInstanceHover={onInstanceHover}
                        onInsertBlock={onInsertBlock}
                        onInsertInlineBlock={onInsertInlineBlock}
                        onRemoveBlock={onRemoveBlock}
                        onUpdateBlock={onUpdateBlock}
                    />
                </div>
            </Drawer>
        </>
    );
};

export default CollapsibleSidePanel; 